// BUG-2564: the B2B entry in the customer drawers (GSTIN search text, the matched B2B
// company, the validated GST details, the picked invoice / delivery address) belongs to
// one cart and one customer. Left over, it carried a GSTIN typed for one bill into the
// next bill's drawer, where turning B2B on validated it for a different customer.

// The cart and customer a B2B entry belongs to. Changes on bill completion, new cart,
// retrieve, and customer add / remove / change.
export const b2bEntryOwnerKey = (cart) => `${cart?.sOrderID || ""}|${cart?.customer?.cwrCustomerId || ""}`;

// True when the cashier turned B2B on and entered B2B details in this drawer session,
// but nothing has been saved as B2B yet (isB2bEnabled is written to local storage only by
// a successful B2B save or by the Add drawer's own toggle).
export const hasUnsavedB2BEntry = ({ isB2BEnabled, lastSearchedValue, gstInfo, selectedB2BCustomer, storedB2B }) =>
  !!isB2BEnabled && !storedB2B && (!!String(lastSearchedValue || "").trim() || !!gstInfo || !!selectedB2BCustomer);
